import {
  IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_BEGIN,
  IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_DISMISS_ERROR,
  IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_FAILURE,
  IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_SUCCESS,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function importItemsFromCsvData(args = {}) {
  return (dispatch) => {
    dispatch({
      type: IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_BEGIN,
    });
    const { projectId, version } = args;
    const promise = new Promise((resolve, reject) => {
      const header = builderSurfaceJsonContentHeader(projectId);
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${args.collectionName}/import`,
        args.formData,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_SUCCESS,
            data: res,
          });
          toast.success('Data Imported Successfully !', {});
          resolve(res);
        },
        (err) => {
          const errorResponse = err.response.data;
          let message =
            errorResponse && errorResponse.message ? errorResponse.message : 'Data Import Failed !';
          let errors = errorResponse ? errorResponse.errors : [];
          dispatch({
            type: IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_FAILURE,
            data: { error: errors },
          });
          toast.error(message, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissImportItemsFromCsvDataError() {
  return {
    type: IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_BEGIN:
      return {
        ...state,
        importItemsFromCsvDataPending: true,
        importItemsFromCsvDataError: null,
        csvData: [],
        csvHeader: [],
      };

    case IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_SUCCESS:
      return {
        ...state,
        importItemsFromCsvDataPending: false,
        importItemsFromCsvDataError: null,
      };

    case IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_FAILURE:
      return {
        ...state,
        importItemsFromCsvDataPending: false,
        importItemsFromCsvDataError: action.data.error,
      };

    case IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_DISMISS_ERROR:
      return {
        ...state,
        importItemsFromCsvDataError: null,
      };

    default:
      return state;
  }
}
